import { render } from "./NPAEmailList.vue?vue&type=template&id=5d158b82"
import script from "./NPAEmailList.vue?vue&type=script&lang=js"
export * from "./NPAEmailList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__